import { render, staticRenderFns } from "./LawyerInputs.vue?vue&type=template&id=59b55bb4&"
import script from "./LawyerInputs.vue?vue&type=script&lang=js&"
export * from "./LawyerInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports